import { createTheme } from '@mui/material'
import { color } from '@mui/system';

const Aquant_new_brand_color  = "#2468FF"; 
const Black                   = "#1F1F1F";
const Black_2                 = "#4A4A4A";
const Grey_1                  = "#818183";
const Grey_2                  = "#999CA1";
const Grey_3                  = "#BFC4CA";
const Grey_4                  = "#DADCDF";
const Grey_6                  = "#F6F7F7";
const Grey_7                  = "#EDEFF580";
const AppBackground           = "#F0F2F5";

const theme = createTheme({
    typography: {
        fontFamily: "Noto Sans Display",
        button: {
            textTransform: "none",
        },
        h1: {
            fontSize: 52,
            fontWeight: 300,
            lineHeight: '64px',
            letterSpacing: 0.2,
        },
        h3: {
            fontSize: 30,
            fontWeight: 300,
            lineHeight: '42px',
            letterSpacing: 0.1,
        },
        h6: {
            fontSize: 20,
            fontWeight: 400,
            lineHeight: '24px',
            letterSpacing: 0.2,
        },
        subtitle1: {
            fontSize: 16,
            fontWeight: 500,
            lineHeight: '24px',
            letterSpacing: 0.1,
        },
        subtitle2: {
            fontSize: 16,
            fontWeight: 300,
            lineHeight: '22px',
            letterSpacing: 0.1,
        },
        body1: {
            fontSize: 13,
            fontWeight: 300,
            lineHeight: '20px',
        },
        body2: {
            fontSize: 13,
            fontWeight: 500,
            lineHeight: '19px',
            letterSpacing: 0.1,
        },
    },
    palette: {
        primary : {
          main : Aquant_new_brand_color,
        },
        background: {
          default: AppBackground,
        },
    },
    components: {
      MuiStepLabel: {
        styleOverrides: {
          label: {
            color: Aquant_new_brand_color,
          },
        },
      },
      MuiButton: { 
        styleOverrides: {
          root: {
            borderRadius: 6,
          },
        },
      },
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: Black,
            color: "#fff",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            height: "100%",
          },
        },
      },
      MuiCardContent: {
        styleOverrides: {
          root: {
            height: "90%",
          },
        },
      },
      MuiCardActions: { 
        styleOverrides: {
          root: {
            justifyContent: 'end',
          },
        },
      },
    },
})

export default theme